import type { ButtonHTMLAttributes } from 'react'

export function Button({ children, busy = false, intent = 'primary', emphasis = 'solid', className = '', disabled, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & {
  busy?: boolean
  intent?: 'primary' | 'neutral' | 'danger'
  emphasis?: 'solid' | 'outline' | 'ghost'
}) {
  return <button type="button" {...props} className={`ui-button ${className}`} data-intent={intent} data-emphasis={emphasis} disabled={disabled || busy} aria-busy={busy || undefined}>
    <span className="button-content" style={{ visibility: busy ? 'hidden' : undefined }}>{children}</span>
    {busy && <span className="button-progress"><span className="spinner" /><span className="sr-only">Procesando…</span></span>}
  </button>
}
